import axios from "axios";

const axiosInstance = axios.create({
  // DEV
  //baseURL: "http://localhost:8080/consumo/api/v1",

  // PROD
  baseURL: "https://candidaturas.consumo.conecta.gov.mz/api/v1",

  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const user = localStorage.getItem("principal");
    if (user) {
      config.headers.Authorization = `Bearer ${JSON.parse(user).accessToken}`;
    }

    // Ensure proper content type for POST/PUT requests
    if (config.method === "post" || config.method === "put") {
      config.headers["Content-Type"] = "application/json";
      config.headers["Accept"] = "application/json";
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;
